import { $, doAction, GA_EVENT } from '@situation/setdesign.util';

$(document).one('TicketCalendar.init', (e, TicketCalendar) => {
    const $on = TicketCalendar.bus.$on.bind(TicketCalendar.bus);
    const useModal = true;
    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            theme: 'wicked-theme',
            // 'breakpoint': 1025,
            'vue-parent':
                $('.js-ticket-calendar-wrap').length ? '.js-ticket-calendar-wrap .container' : '.ticket-calendar',
            fullcalendar: { aspectRatio: 1.1, firstDay: 1, timeFormat: 'h.mm A' },
            'scroll-calendar': { dateFormat: ['ddd', 'DD', 'h.mm A'] },
            mobiscroll: { height: 35 },
            'tag-highlighter': { instructionText: '' },
            'calendar-week-header': { headerFormat: 'ddd, MMM D' },
            'accordion-month': { useModal },
            'calendar-week': { useModal },
            'calendar-week-events': { eventFormat: 'h.mm A' },
            'calendar-list': { useModal },
            'calendar-list-item': { eventDateFormat: 'dddd, D MMM', eventTimeFormat: 'h.mm A' },
            'accordion-month-header': { arrowSvgName: 'icon-angle-down' },
            'selected-event': {
                description: 'Performance Selected:',
                confirming: false,
                eventFormat(event) {
                    const dateFormat = 'ddd. D. MMM';
                    const timeFormat = event.start.minute() > 0 ? 'h.mm' : 'h';
                    return `${event.format(dateFormat)} at ${event.format(`${timeFormat}a`)}`;
                },
            },
        });
    });

    function getEventLabel(event) {
        return [event.performance.value, event.format('dddd')].join('_');
    }

    $on('click-event', (event, component) => {
        let label = getEventLabel(event);
        if (component === 'calendar-week' || component === 'calendar-list') {
            label = `Home_${label}`;
        }

        doAction(GA_EVENT, ['IntentToBuy', 'Select_date', label]);
    });

    $on('select-event', (event, component) => {
        if (component === 'fullcalendar' && useModal) {
            doAction(GA_EVENT, ['Ticketing_info', 'View_popover', getEventLabel(event)]);
        }
    });

    $on('toggle-month', (month) => {
        const action = [month.active ? 'Hide' : 'Expand', 'month'].join('_');
        doAction(GA_EVENT, ['Ticketing_info', action, month.format('YYYY-MMMM')]);
    });

    TicketCalendar.components.update('selected-event', {
        methods: {
            clickEvent(linkIndex, nativeEvent) {
                if (linkIndex === 0) {
                    nativeEvent.preventDefault();
                    this.confirming = true;
                } else {
                    this.$emit('click-event', this.event);
                    TicketCalendar.bus.$emit(
                        'click-event',
                        this.event,
                        this.context,
                        nativeEvent.currentTarget,
                        linkIndex,
                    );
                }
            },
            clickConfirm(linkIndex, nativeEvent) {
                this.$emit('click-event', this.event);
                TicketCalendar.bus.$emit(
                    'click-event',
                    this.event,
                    this.context,
                    nativeEvent.currentTarget,
                    linkIndex,
                );
            },
            clickBack() {
                this.confirming = false;
            },
        },
        template: html`<div class="tc-selected-event" :class="cssClasses">
            <div v-show="!confirming" class="tc-selected-event__info-wrap">
                <div class="tc-selected-event__description" v-html="description"></div>
                <div class="tc-selected-event__date-time" v-html="eventHtml"></div>
            </div>
            <div
                v-show="!confirming"
                class="tc-selected-event__info-wrap tc-selected-event__info-wrap--before-link"
                v-if="hasMessageBeforeLink"
                v-html="messageBeforeLink"></div>
            <div v-show="!confirming" class="tc-selected-event__link-wrap">
                <a
                    v-if="eventSoldOut"
                    class="tc-selected-event__link"
                    disabled
                    :class="buttonClass"
                    v-html="linkTextSoldOut"></a>
                <div v-else v-for="(link, index) in event.links" :key="index" class="tc-selected-event__link-col">
                    <a
                        class="tc-selected-event__link"
                        :class="buttonClass"
                        :href="link.url"
                        @click="clickEvent(index, $event)"
                        target="_blank"
                        v-html="link.label"
                        data-gtm="0"></a>
                    <div
                        v-if="link.description"
                        class="tc-selected-event__link-description"
                        v-html="link.description"></div>
                </div>
            </div>
            <div
                v-show="!confirming"
                class="tc-selected-event__info-wrap tc-selected-event__info-wrap--after-link"
                v-if="hasMessageAfterLink"
                v-html="messageAfterLink"></div>
            <div v-show="confirming" class="tc-selected-event__confirm">
                <p>
                    You are now leaving our site to book via ATG Tickets at the Apollo Victoria Theatre. Once on
                    this site, you will be subject to their privacy practices and controls.
                </p>
                <div class="tc-selected-event__link-wrap">
                    <div class="tc-selected-event__link-col">
                        <a @click.prevent="clickBack" href="#" class="btn btn-default btn-block">Go Back</a>
                    </div>
                    <div class="tc-selected-event__link-col">
                        <a
                            :href="event.links[0].url"
                            :class="buttonClass"
                            @click="clickConfirm(0, $event)"
                            target="_blank"
                            data-gtm="0"
                            >Continue</a
                        >
                    </div>
                </div>
            </div>
        </div>`,
    });
});
